<template>
  <div
    class="app-main-inner tracking-detail"
    style="display: flex;flex-direction: column;"
  >
    <div class="app-main-inner-row">
      <div class="filters">
        <template v-if="!optStatus.edit">
          <el-button type="primary" :disabled="showSop" @click="showAdd">{{ $t('SystemMaintenance.CreateStatusDetail') }}</el-button>
          <el-button v-show="!isNew" type="primary" :disabled="showSop" @click="showEdit">{{ $t('SystemMaintenance.Edit') }}</el-button>
          <el-button v-show="!isNew" type="danger" :disabled="showSop" @click="toDel">{{ $t('SystemMaintenance.Delete') }}</el-button>

        </template>
        <template v-else>
          <el-button type="primary" @click="save">{{ $t('SystemMaintenance.Save') }}</el-button>
          <el-button type="primary" @click="cancel">{{ $t('SystemMaintenance.Cancel') }}</el-button>
          <el-button v-show="!isNew" type="danger" @click="toDel">{{ $t('SystemMaintenance.Delete') }}</el-button>

        </template>
        <el-button :disabled="optStatus.edit|| optStatus.sopEdit" type="danger" @click="toConfigSop">{{ $t('SystemMaintenance.ConfigureSOPMessagePush') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row" style="height: calc( 100% - 45px)">
      <div style="display: flex;flex-direction: column;">
        <!--明细-->
        <el-card class="box-card" style="height: 50%;">
          <div slot="header">
            <span>{{ !isNew?$t('SystemMaintenance.EditStatusDetail'):$t('SystemMaintenance.CreateStatusDetail') }}</span>
          </div>
          <el-form ref="trackingDetailForm" style="width:100%;" label-position="left" label-width="90px">
            <el-form-item :label="$t('SystemMaintenance.SerialNumber')">
              <el-input-number
                v-model="trackingDetailForm.level"
                controls-position="right"
                :disabled="!optStatus.edit"
              />
              <el-checkbox v-model="trackingDetailForm.defaultNode" :disabled="!optStatus.edit" style="margin-left: 5px">{{ $t('SystemMaintenance.InitialStatus') }}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.Code')">
              <el-input
                v-model="trackingDetailForm.code"
                :disabled="!optStatus.edit"
              />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.ChineseName3')">
              <el-input
                v-model="trackingDetailForm.codeCname"
                :disabled="!optStatus.edit"
              />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.EnglishName3')">
              <el-input
                v-model="trackingDetailForm.codeEname"
                :disabled="!optStatus.edit"
              />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.StatusType')">
              <el-select v-model="trackingDetailForm.stateType" :disabled="!optStatus.edit">
                <el-option v-for="item in stateTypes" :key="item.value" :label="item.chineseName" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="trackingDetailForm.type" :disabled="!optStatus.edit">{{ $t('SystemMaintenance.AutomaticTrigger') }}</el-checkbox>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TriggerType')">
              <cargo-advance-select
                :disabled="!optStatus.edit||!(trackingDetailForm.type)"
                filterable
                :select-type="selectTypeNames.basic_data_EntityTriggerType"
                :cache="false"
                :headers="['CODE',$t('SystemMaintenance.EnglishName3')]"
                :fields="['fieldCode','fieldEname']"
                :callback-params="{key:'event'}"
                callback-method-type="obj"
                :default-value="trackingDetailForm.event"
                :static-options="triggerTypeList"
                tag-value="uuid"
                tag-name="fieldName"
                :filter-tag-names="['fieldCode','fieldEname']"
                style="width:205px;"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item v-show="currentTriggerObj.fieldCode==='_itrace_code'" :label="$t('SystemMaintenance.ExternalCode')">
              <cargo-advance-select
                filterable
                :url="url.sys.trackingDetailExternal"
                :headers="['CODE',$t('SystemMaintenance.Name')]"
                :fields="['code','serviceName']"
                :callback-params="{key:'externalCode'}"
                :disabled="!optStatus.edit"
                callback-method-type="value"
                :default-value="trackingDetailForm.externalCode"
                :static-options="sopExternalCodeConfigList"
                tag-value="code"
                tag-name="serviceName"
                :filter-tag-names="['code','serviceName']"
                style="width:205px;"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item v-if="currentTriggerObj.fieldEname==='生成电子文件'" :label="$t('SystemMaintenance.FileType')">
              <cargo-advance-select
                filterable
                :url="url.sys.docTypeByLob"
                :headers="['CODE',$t('SystemMaintenance.ChineseName3')]"
                :fields="['code','name']"
                :method-params="{lob:currentLob}"
                :callback-params="{key:'documentTypeUuid'}"
                :disabled="!optStatus.edit"
                callback-method-type="obj"
                :static-options="documentTypeList"
                :default-value="trackingDetailForm.documentTypeUuid"
                tag-value="uuid"
                tag-name="name"
                :filter-tag-names="['code','name']"
                style="width:205px;"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.DataService')">
              <cargo-advance-select
                filterable
                clearable
                :disabled="!optStatus.edit"
                :static-options="dataServices"
                :default-value="trackingDetailForm.dataService"
                tag-value="code"
                :filter-tag-names="['englishName','chineseName']"
                style="width:205px;"
                @parentCallBack="p=>{trackingDetailForm.dataService=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.PublicOrNot')">
              <el-checkbox v-model="trackingDetailForm.published" :disabled="!optStatus.edit" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.ReportTemplate')">
              <cargo-advance-select
                filterable
                :headers="[$t('SystemMaintenance.ChineseName3')]"
                :fields="['name']"
                :callback-params="{key:'templateUuid'}"
                :disabled="!optStatus.edit"
                callback-method-type="value"
                :default-value="trackingDetailForm.templateUuid"
                :static-options="templateList"
                tag-value="uuid"
                tag-name="name"
                :filter-tag-names="['name']"
                style="width:205px;"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>

            <el-form-item :label="$t('SystemMaintenance.Remark')">
              <el-input
                v-model="trackingDetailForm.remark"
                type="textarea"
                :rows="3"
                :disabled="!optStatus.edit"
              />
            </el-form-item>

            <el-form-item :label="$t('FinanceManage.charge_sp7')">
              <el-input
                v-model="txtCharge"
                style="width: 80%;padding-right: 10px"
                :disabled="true"
              />
              <el-button type="primary" :disabled="!optStatus.edit" @click="selectHandler">{{ $t('CargoMsg.Cargo_Select') }}</el-button>
            </el-form-item>
          </el-form>
        </el-card>
        <!--预警设置-->
        <tracking-detail-sop-warning-config ref="trackWarningConfig" :opt-status-edit="optStatus.edit" :tracking-detail="trackingDetailForm" />
        <!--状态变更通知-->
        <el-card ref="trackNoteByInside" :class="['box-card',optStatus.edit?'':'not-click'] " style="height: 30%;">
          <div slot="header" style="padding: 2px 0">
            <span>{{ $t('SystemMaintenance.StatusChangeNotification') }}</span>
          </div>
          <el-form style="width:100%;" label-position="left" label-width="0px">
            <el-form-item label="">
              <el-radio-group v-model="trackingDetailForm.sendInnerNotify" :disabled="!optStatus.edit">
                <el-radio :label="true">{{ $t('SystemMaintenance.SendNotification') }}</el-radio>
                <el-radio :label="false">{{ $t('SystemMaintenance.DoNotSendNotification') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="trackingDetailForm.innerConfig.post" :disabled="!optStatus.edit">{{ $t('SystemMaintenance.DesignatedPost') }}</el-checkbox>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="trackingDetailForm.innerConfig.sales" :disabled="!optStatus.edit">{{ $t('SystemMaintenance.Sales') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.op" :disabled="!optStatus.edit">{{ $t('SystemMaintenance.Operation') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.csr" :disabled="!optStatus.edit">{{ $t('SystemMaintenance.CustomerService') }}</el-checkbox>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="trackingDetailForm.innerConfig.overseaOp" :disabled="!optStatus.edit">{{ $t('SystemMaintenance.OverseasCustomerService') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.dc" :disabled="!optStatus.edit">{{ $t('SystemMaintenance.Document') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.planner" :disabled="!optStatus.edit">{{ $t('SystemMaintenance.LineManager') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.siteOp" :disabled="!optStatus.edit">{{ $t('SeaExport.FieldOperation') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.userDefinedRoleId1" :disabled="!optStatus.edit">{{ $t('CargoMsg.Cargo_userDefinedRole1') }}</el-checkbox>
              <el-checkbox v-model="trackingDetailForm.innerConfig.userDefinedRoleId2" :disabled="!optStatus.edit">{{ $t('CargoMsg.Cargo_userDefinedRole2') }}</el-checkbox>
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="trackingDetailForm.innerConfig.personnel" :disabled="!optStatus.edit" @change="trackingDetailForm.innerConfig.userList=[]">{{ $t('SystemMaintenance.DesignatedPersonnel') }}</el-checkbox>
            </el-form-item>
            <el-form-item label="">
              <cargo-advance-select
                :select-type="selectTypeNames.basic_data_User"
                :fields="['chineseName']"
                :disabled="!optStatus.edit||!trackingDetailForm.innerConfig.personnel"
                :callback-params="{key:'userList'}"
                callback-method-type="value"
                tag-value="userId"
                tag-name="chineseName"
                :filter-tag-names="['chineseName']"
                :method-params="{pageSize: 1000000, active: true, hasRole: true}"
                :default-multiple-value="trackingDetailForm.innerConfig.userList"
                multiple
                filterable
                style="width:205px;"
                options-width="230px"
                @parentCallBack="getInnerConfigValueFromChild"
              />
            </el-form-item>
            <el-form-item label="">
              <el-checkbox v-model="trackingDetailForm.innerConfig.email" :disabled="!optStatus.edit">{{ $t('SystemMaintenance.Email') }}</el-checkbox>
            </el-form-item>
          </el-form>
        </el-card>
        <!--API输出附加信息-->
        <tracking-detail-notify-ext-panel ref="trackNotifyExt" :opt-status-edit="optStatus.edit" :is-new="isNew" :tracking-detail="trackingDetailForm" />
      </div>
      <!--sop推送日志-->
      <el-card v-show="showSop" class="box-card" style="flex-grow: 1">
        <div slot="header">
          <span>{{ $t('SystemMaintenance.SopPushLog') }}</span>
        </div>
        <div class="app-main-inner-row">
          <div>
            <el-button v-if="optStatus.sopCellEdit" type="primary" @click="saveSopCellEdit">{{ $t('SystemMaintenance.Confirm') }}</el-button>
            <el-button v-if="optStatus.sopCellEdit" type="primary" @click="cancelSopCellEdit">{{ $t('SystemMaintenance.Cancel') }}</el-button>
            <el-button v-if="!optStatus.sopCellEdit" type="primary" @click="showEditSop">{{ $t('SystemMaintenance.Edit') }}</el-button>
            <el-button v-if="!optStatus.sopCellEdit" type="danger" @click="delSop">{{ $t('SystemMaintenance.Delete') }}</el-button>
          </div>
        </div>
        <div class="app-main-inner-row">
          <cargo-ag-grid
            :show-side-bar="false"
            :column-defs="sopGrid.columnDefs"
            :row-data="sopGrid.rowData"
            :grid-options="sopGrid.gridOptions"
            style="width: 100%;height:200px;"
            @gridReady="onSopReady"
          />
        </div>
        <el-form ref="trackingDetailForm" style="width:100%;" label-position="left" label-width="90px">
          <el-form-item :label="$t('SystemMaintenance.PushTarget')">
            <el-select v-model="sopForm.pushObject" :disabled="!optStatus.sopEdit" style="width:300px;">
              <el-option v-for="item in pushObjects" :key="item.name" :label="item.chineseName" :value="item.name" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SystemMaintenance.PushChannel')">
            <el-select v-model="sopForm.pushChannel" :disabled="!optStatus.sopEdit" style="width:300px;">
              <el-option v-for="item in pushChannels" :key="item.value" :label="item.name" :value="item.value" />
            </el-select>
            <el-checkbox v-model="sopForm.sendAlone" style="padding-left: 10px" :label="$t('CargoMsg.Cargo_SendToEachRecipientSeparately')" />
          </el-form-item>
          <template v-if="sopForm.pushChannel===0">
            <!--邮件部分star-->
            <el-form-item :label="$t('SystemMaintenance.SubjectTemplate')">
              <el-input
                v-model="sopForm.templateTitle2Email"
                :disabled="!optStatus.sopEdit"
                @focus="eFocus=constant.eFocus.emailTitle"
              />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.TextTemplate')" style="height: 180px;">
              <quill-editor
                ref="emailTextQuillEditor"
                v-model="sopForm.templateText2Email"
                :disabled="!optStatus.sopEdit"
                :options="editorOption"
                style="height: 130px;"
                @focus="onEditorFocus($event)"
              />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.DataItem')" :class="{'not-click':!optStatus.sopEdit}">
              <el-button v-for="(item,index) in sopDataItems" :key="index" type="" style="margin-left: 0px;margin-right: 10px;" @click="onClickSopDataItem(index)">{{ item }}</el-button>
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.AttachmentFileType')">
              <el-input v-show="!optStatus.sopEdit" v-model="currFileTypeNames" style="width:300px;" :disabled="true" />
              <el-dropdown v-show="optStatus.sopEdit" trigger="click" placement="bottom-start">
                <span class="el-dropdown-link">
                  <el-input v-model="currFileTypeNames" style="width:300px;" :placeholder="$t('Message.PleaseEnterTheFileType')" />
                </span>
                <el-dropdown-menu slot="dropdown" class="app-main-inner-row row-grid" style="width: 350px;height: 200px;">

                  <cargo-ag-grid
                    :show-side-bar="false"
                    :grid-options="fileTreeGrid.gridOptions"
                    :column-defs="fileTreeGrid.columnDefs"
                    :row-data="fileTreeGrid.rowData"
                    style="width:100%;height:100%;"
                  />
                </el-dropdown-menu>
              </el-dropdown>
            </el-form-item>
          </template>
          <template v-if="sopForm.pushChannel===1">
            <!--短信部分star-->
            <el-form-item :label="$t('SystemMaintenance.TemplateSubject')">
              <el-select v-model="sopForm.templateTheme" :disabled="!optStatus.sopEdit" style="width:300px;">
                <el-option v-for="item in templateThemes" :key="item.code" :label="item.chineseName" :value="item.code" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.TemplateContent')">
              <el-input
                v-model="sopForm.templateTitle2Note"
                disabled
                type="textarea"
                :rows="5"
                @focus="eFocus=constant.eFocus.noteContent"
              />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.TemplateExample')">
              <el-input
                v-model="sopForm.templateText2Note"
                type="textarea"
                :rows="5"
                disabled
              />
            </el-form-item>
          </template>
        </el-form>
        <div class="app-main-inner-row" style="justify-content: center">
          <el-button v-if="!optStatus.sopCellEdit" type="primary" @click="saveSop">{{ $t('SystemMaintenance.Confirm') }}</el-button>
          <el-button v-if="!optStatus.sopCellEdit" type="primary" @click="cancelSop">{{ $t('SystemMaintenance.Cancel') }}</el-button>
          <el-button type="primary" @click="showSendSopTest">{{ $t('SystemMaintenance.SendTest') }}</el-button>
        </div>
      </el-card>
    </div>
    <el-dialog
      :visible.sync="sendSopTest.visible"
      :title="$t('SystemMaintenance.SendTest')"
      width="400px"
      close-on-click-modal
    >
      <span>{{ $t('SystemMaintenance.SendTo') }}</span>
      <el-input v-model="sendSopTest.target" style="width: 200px" />
      <div slot="footer" style="text-align: center;">
        <el-button type="primary" @click="sendSopTestHandler">{{ $t('SystemMaintenance.Confirm') }}</el-button>
        <el-button type="primary" @click="sendSopTestCloseHandler">{{ $t('SystemMaintenance.Cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 费用方案导入弹窗 -->
    <tracking-charge-scheme-batch-dialog
      :visible.sync="chargePlanDialog.visible"
      :lob="chargePlanDialog.lob"
      :is-sea="chargePlanDialog.isSea"
      :selected-list="chargePlanDialog.selectList"
      @selectedSchemeHandler="(schemeDetails) => { selectedSchemeHandler(schemeDetails) }"
    />
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor' // 调用富文本编辑器
import 'quill/dist/quill.snow.css' // 富文本编辑器外部引用样式  三种样式三选一引入即可
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as TrackingTemplateConfigApi from '@/api/sysManage/baseConfig/businessManage'
import * as entityTriggerTypeApi from '@/api/sysManage/baseConfig/entityTriggerType'
import * as sopExternalCodeConfigApi from '@/api/sysManage/baseConfig/sopExternalCodeConfig'
import TrackingDetailSopWarningConfig from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/business/TrackingDetailSopWarningConfig'
import TrackingDetailNotifyExtPanel from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/business/TrackingDetailNotifyExtPanel'
import { getLoading } from '@/utils/utilBaseElement'
import {
  getDocTypeByLob,
  getTemplateTheme,
  getTrackingSopDetail,
  saveTrackingSop,
  delTrackingSop,
  getTrackingSopList,
  delTrackingDetail,
  saveTrackingDetail,
  saveTrackingDetailBatch,
  getTrackingDetailByUuid,
  queryChargeSchemeDetailTrackingFunc, saveChargeSchemeDetailTrackingFunc
} from '@/api/sysManage/baseConfig/businessManage'
import * as templateApi from '@/api/sysManage/baseConfig/template'
import { Assert } from '@/utils/validate'
import ZH from '@/lang/zh'
import { deepClone } from '@/utils'
import URL from '@/api/urlTranslator'

import { getGridSelected } from '@/utils/agGrid'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import TrackingChargeSchemeBatchDialog from '@/views/cargo/v0/SeaExport/components/booking/TrackingChargeSchemeBatchDialog'
import * as SopConstants from '@/class/cargo/model/parameters/SopConstants'
export default {
  name: 'TrackingDetail',
  components: {
    quillEditor,
    cargoAdvanceSelect,
    TrackingDetailSopWarningConfig,
    TrackingChargeSchemeBatchDialog,
    TrackingDetailNotifyExtPanel
  },
  props: {
    treeNode: {
      type: Object,
      required: true
    },
    trackingList: { type: Array, default: null }
  },
  data() {
    return {
      loading: false,
      isNew: false, // 新建实体
      isNewSop: false, // 新建sop
      showSop: false,
      optStatus: {
        edit: false,
        sopEdit: false,
        sopCellEdit: false
      },
      chargePlanDialog: {
        visible: false,
        selectList: [],
        isSea: false,
        lob: 'SE'
      },
      selectTypeNames: TYPE_NAMES,
      editorOption: {
        // some quill options
        placeholder: this.$t('SystemMaintenance.PleaseEnterContent'),
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            ['clean']
          ]
        }
      },
      stateTypes: [ // 状态类型
        { name: 'STATE_TYPE_NOT_START', value: 1, chineseName: '未开始', englishName: 'NotStart' },
        { name: 'STATE_TYPE_IN', value: 2, chineseName: '进行中', englishName: 'In' },
        { name: 'STATE_TYPE_COMPLETE', value: 3, chineseName: '已完成', englishName: 'Complete' },
        { name: 'STATE_TYPE_EXCPTION', value: 4, chineseName: '异常', englishName: 'Exception' }
      ],
      allTemplateTheme: { // 模板主题全量
        SMS_471385302: { name: 'SMS_471385302', code: 'SMS_471385302', chineseName: '订舱成功', englishName: 'Successful Booking' },
        SMS_471455277: { name: 'SMS_471455277', code: 'SMS_471455277', chineseName: '入仓通知', englishName: 'Warehouse Notice' },
        SMS_471475272: { name: 'SMS_471475272', code: 'SMS_471475272', chineseName: '报关放行', englishName: 'Customs clearance' },
        SMS_471480298: { name: 'SMS_471480298', code: 'SMS_471480298', chineseName: '开航通知', englishName: 'Navigation Notice' },
        SMS_471485278: { name: 'SMS_471485278', code: 'SMS_471485278', chineseName: '签发提单', englishName: 'issue a bill of lading' }
      },
      allPushChannel: [{ name: this.$t('constant.email'), value: 0 }, { name: this.$t('constant.note'), value: 1 }],
      allPushObject2: [ // 推送对象全量
        { name: 'customer', chineseName: '客户', englishName: 'CUSTOMER' },
        { name: 'DestinationAgent', chineseName: '目的港代理', englishName: 'Destination Agent' },
        { name: 'DesignationAgent', chineseName: '指定货代理', englishName: 'Designation Agent' },
        { name: 'PortOfLoadingAgent', chineseName: '起运港代理', englishName: 'PortOfLoading Agent' },
        { name: 'DesignatedPostsAndPersonnel', chineseName: '指定岗位和指定人员', englishName: 'Designated posts and designated personnel' }
      ],
      allPushObject: { // 推送对象全量
        CUSTOMER: { name: 'customer', chineseName: '客户', englishName: 'CUSTOMER' },
        DESTINATION_AGENT2: { name: 'DestinationAgent', chineseName: '目的港代理', englishName: 'Destination Agent' },
        DESIGNATION_AGENT2: { name: 'DesignationAgent', chineseName: '指定货代理', englishName: 'Designation Agent' },
        DESIGNATION_AGENT3: { name: 'PortOfLoadingAgent', chineseName: '起运港代理', englishName: 'PortOfLoading Agent' },
        DesignatedPostsAndPersonnel: { name: 'DesignatedPostsAndPersonnel', chineseName: '指定岗位和指定人员', englishName: 'Designated posts and designated personnel' }
      },
      constant: {
        eFocus: { emailTitle: 'emailTitle', emailContent: 'emailContent', noteTitle: 'noteTitle', noteContent: 'noteContent' }
      },
      eFocus: '', // 获取焦点的元素 （email:标题、文本，msg:标题、文本）
      initTrackingDetailForm: {

      },
      sourceType: {
        parent: this.treeNode.type === 2,
        self: this.treeNode.type === 3
      },
      currentLob: this.treeNode.path.split(',')[0], // Lob 类型
      currentTriggerObj: {}, // 当前触发类型选项
      txtCharge: '',
      chargeSchemeDetailTrackingList: [],
      trackingDetailForm: {
        acrossTenant: false,
        applyType: 0,
        clientRefCode: '',
        code: '',
        codeCname: '',
        codeEname: '',
        defaultNode: false,
        dirty: false,
        documentTypeUuid: '',
        event: '',
        extendedData: '',
        externalCode: '',
        innerConfig: {
          sales: false,
          overseaOp: false,
          dc: false,
          planner: false,
          op: false,
          csr: false,
          post: false,
          personnel: false,
          cargoSales: false,
          siteOp: false, // 现场操作
          userDefinedRoleId1: false, // 自定义岗位1
          userDefinedRoleId2: false, // 自定义岗位2
          userList: [], // 用户id逗号隔开
          email: false,
          stationNotice: false,
          weChat: false
        },
        level: 2,
        published: false,
        remark: '',
        sendInnerNotify: false,
        stateType: 1,
        templateUuid: '',
        trackingUuid: '',
        type: false,
        uuid: ''
      },
      sopGrid: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          defaultColDef: {
            resizable: true,
            filter: true
          },
          onRowClicked: this.onSopRowClick
        },
        gridParams: {},
        gridApi: {},
        columnDefs: [
          {
            headerName: this.$t('SystemMaintenance.PushTarget'),
            width: 200,
            field: 'pushObject',
            cellRenderer: (params) => {
              const row = this.allPushObject2.find(item => {
                return item.name === params.value
              })
              return row ? row.chineseName : params.value
            }
          }, {
            headerName: this.$t('SystemMaintenance.PushChannel'),
            width: 300,
            field: 'pushChannel',
            cellRenderer: (params) => {
              const row = this.allPushChannel.find(item => {
                return item.value === params.value
              })
              return row ? row.name : params.value
            }
          }
        ],
        sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
        rowData: []
      },
      currFileTypeNames: '',
      fileTreeGrid: {
        gridOptions: {
          rowSelection: 'multiple',
          groupDefaultExpanded: 1,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('SystemMaintenance.Name'),
            width: 280,
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: true,
              innerRenderer: (params) => {
                if (params.data.level === 0) { return params.data.chineseName }
                return `${params.node.childIndex}.` + params.data.chineseName
              },
              checkbox: (params) => {
                return params.data.type === 2
              }
            }
          }
        },
        rowData: [],
        columnDefs: []
      },
      initSopFrom: {

      },
      sopForm: {
        uuid: '',
        pushChannel: 0,
        sendAlone: false,
        pushObject: 'customer',
        lob: '',
        templateTitle: '',
        templateText: '',

        templateTitle2Email: '',
        templateText2Email: '',

        templateTitle2Note: '',
        templateText2Note: '',
        templateTheme: '', // 短信模板主题
        fileId: '', // 附件类型
        trackingDetailUuid: '',
        pushNode: ''// trackingDetail.codeCname 推送节点

      },
      sendSopTest: {
        visible: false,
        target: ''
      },
      templateList: [],
      triggerTypeList: [],
      sopExternalCodeConfigList: [],
      documentTypeList: [],
      docTypeMap: new Map(),
      dataServices: SopConstants.DATA_SERVICES
    }
  },
  computed: {
    emailTextQuillEditor() {
      return this.$refs.emailTextQuillEditor.quill
    },
    url() {
      return URL
    },
    templateThemes() { // 模板主题
      const themes = []
      switch (this.currentLob) {
        case 'SE':
          themes.push(this.allTemplateTheme.SMS_471385302)
          themes.push(this.allTemplateTheme.SMS_471455277)
          themes.push(this.allTemplateTheme.SMS_471475272)
          themes.push(this.allTemplateTheme.SMS_471480298)
          themes.push(this.allTemplateTheme.SMS_471485278)

          break
        case 'SI':

          themes.push(this.allTemplateTheme.SMS_471385302)
          themes.push(this.allTemplateTheme.SMS_471455277)
          themes.push(this.allTemplateTheme.SMS_471475272)
          themes.push(this.allTemplateTheme.SMS_471480298)
          themes.push(this.allTemplateTheme.SMS_471485278)

          break
        case 'AE':
          themes.push(this.allTemplateTheme.SMS_471385302)
          themes.push(this.allTemplateTheme.SMS_471455277)
          themes.push(this.allTemplateTheme.SMS_471475272)
          themes.push(this.allTemplateTheme.SMS_471480298)
          themes.push(this.allTemplateTheme.SMS_471485278)
          break
        case 'AI':

          themes.push(this.allTemplateTheme.SMS_471385302)
          themes.push(this.allTemplateTheme.SMS_471455277)
          themes.push(this.allTemplateTheme.SMS_471475272)
          themes.push(this.allTemplateTheme.SMS_471480298)
          themes.push(this.allTemplateTheme.SMS_471485278)
          break
      }
      return themes
    },
    pushChannels() { // 推送渠道
      if (this.currentLob === 'SE' && this.sopForm.pushObject === 'customer') {
        return [{ name: this.$t('constant.email'), value: 0 }, { name: this.$t('constant.note'), value: 1 }]
      } else {
        return [{ name: this.$t('constant.email'), value: 0 }]
      }
    },
    pushObjects() { // 推送对象
      let pushObject = []
      switch (this.sopForm.pushChannel) {
        case 0: // email
          switch (this.currentLob) {
            case 'RE':
            case 'RI':
            case 'SE':
              pushObject = [this.allPushObject.CUSTOMER, this.allPushObject.DESIGNATION_AGENT2, this.allPushObject.DESTINATION_AGENT2, this.allPushObject.DesignatedPostsAndPersonnel]
              break
            case 'SI':
              pushObject = [this.allPushObject.CUSTOMER, this.allPushObject.DESIGNATION_AGENT3, this.allPushObject.DESIGNATION_AGENT2, this.allPushObject.DesignatedPostsAndPersonnel]
              break
            case 'AE':
              pushObject = [this.allPushObject.CUSTOMER, this.allPushObject.DESIGNATION_AGENT2, this.allPushObject.DESTINATION_AGENT2, this.allPushObject.DesignatedPostsAndPersonnel]
              break
            case 'AI':
              pushObject = [this.allPushObject.CUSTOMER, this.allPushObject.DESIGNATION_AGENT2, this.allPushObject.DESIGNATION_AGENT3, this.allPushObject.DesignatedPostsAndPersonnel]
              break
          }
          break
        case 1:
          pushObject = [this.allPushObject.CUSTOMER]
          break
      }
      return pushObject
    },
    sopDataItems() {
      const sopDataItem = [] // 数据项
      // SE
      const lob = this.treeNode.path.split(',')[0]
      switch (lob) {
        case 'SE':
          sopDataItem.push(ZH.constant.sop.JOB_NO)
          sopDataItem.push(ZH.constant.sop.CUSTOMER_ID_CN)
          sopDataItem.push(ZH.constant.sop.CUSTOMER_ID_US)
          sopDataItem.push(ZH.constant.sop.DESTINATION_AGENT)
          sopDataItem.push(ZH.constant.sop.DESIGNATION_AGENT)
          sopDataItem.push(ZH.constant.sop.BARGE_POL)
          sopDataItem.push(ZH.constant.sop.LOADING_PORT_CODE)
          sopDataItem.push(ZH.constant.sop.LOADING_PORT_CODE3)

          sopDataItem.push(ZH.constant.sop.DESTINATION_PORT_CODE)
          sopDataItem.push(ZH.constant.sop.DESTINATION_PORT_CODE2)
          sopDataItem.push(ZH.constant.sop.DISCHARGING_PORT)
          sopDataItem.push(ZH.constant.sop.DISCHARGING_PORT2)
          sopDataItem.push(ZH.constant.sop.CARRIER_CN)
          sopDataItem.push(ZH.constant.sop.CARRIER_US)
          sopDataItem.push(ZH.constant.sop.CARRIER_CODE)
          sopDataItem.push(ZH.constant.sop.CARRIER_SHORT_NAME)
          sopDataItem.push(ZH.constant.sop.VESSEL)
          sopDataItem.push(ZH.constant.sop.VOYAGE)
          sopDataItem.push(ZH.constant.sop.WAREHOUSE_NO)

          sopDataItem.push(ZH.constant.sop.SO_NO)
          sopDataItem.push(ZH.constant.sop.MBL)
          sopDataItem.push(ZH.constant.sop.HBL_NO)
          sopDataItem.push(ZH.constant.sop.ETD)
          sopDataItem.push(ZH.constant.sop.ETA)
          sopDataItem.push(ZH.constant.sop.ATD)
          sopDataItem.push(ZH.constant.sop.ATA)
          sopDataItem.push(ZH.constant.sop.CUSTOMS_DATE)

          sopDataItem.push(ZH.constant.sop.CUSTOMER_REF_NO)
          sopDataItem.push(ZH.constant.sop.QUANTITY)
          sopDataItem.push(ZH.constant.sop.WEIGHT)
          sopDataItem.push(ZH.constant.sop.VOLUME)
          sopDataItem.push(ZH.constant.sop.CONTAINER_NO)
          sopDataItem.push(ZH.constant.sop.CONTAINER_DESC)
          sopDataItem.push(ZH.constant.sop.DOWNLOAD_URL)

          sopDataItem.push(ZH.constant.sop.CONSIGNEE_CODE)
          sopDataItem.push(ZH.constant.sop.STATUS_UPDATE_TIME)
          sopDataItem.push(ZH.constant.sop.USER_DEFINED_FIELD1)
          sopDataItem.push(ZH.constant.sop.USER_DEFINED_FIELD2)
          sopDataItem.push(ZH.constant.sop.USER_DEFINED_FIELD3)
          sopDataItem.push(ZH.constant.sop.ESTIMATED_SHIPPING_DATE)

          sopDataItem.push(ZH.constant.sop.CSR)
          sopDataItem.push(ZH.constant.sop.CSR_PHONE)
          sopDataItem.push(ZH.constant.sop.CSR_EMAIL)
          sopDataItem.push(ZH.constant.sop.OVERSEA_OP_EMAIL)
          sopDataItem.push(ZH.constant.sop.DC_EMAIL)
          sopDataItem.push(ZH.constant.sop.PORT_DISTRICT)
          sopDataItem.push(ZH.constant.sop.TERMINAL_OPENDATE)
          sopDataItem.push(ZH.constant.sop.TERMINAL_CUTOFF)

          sopDataItem.push(ZH.constant.sop.REAL_ARRIVALS_DATE)
          sopDataItem.push(ZH.constant.sop.BERTH_PLAN_DATE)
          sopDataItem.push(ZH.constant.sop.ACTUAL_BERTH_PLAN_DATE)
          sopDataItem.push(ZH.constant.sop.UN_BERTH_PLAN_DATE)
          sopDataItem.push(ZH.constant.sop.ACTUAL_UN_BERTH_PLAN_DATE)

          sopDataItem.push(ZH.constant.sop.BERTH_PLAN_PLACE)
          sopDataItem.push(ZH.constant.sop.ACTUAL_BERTH_PLAN_PLACE)
          sopDataItem.push(ZH.constant.sop.OP_EMAIL)
          sopDataItem.push(ZH.constant.sop.DESTINATION_AGENT_EMAIL)
          sopDataItem.push(ZH.constant.sop.CUTOFF_TIME)
          sopDataItem.push(ZH.constant.sop.EstimatedArrivalTime)
          sopDataItem.push(ZH.constant.sop.actualArrivalTime)
          sopDataItem.push(ZH.constant.sop.PortDischargeTime)
          sopDataItem.push(ZH.constant.sop.ActualLiftingDate)
          sopDataItem.push(ZH.constant.sop.ActualReturnTime)
          sopDataItem.push(ZH.constant.sop.MBLTransportationClause)
          sopDataItem.push(ZH.constant.sop.HBLTransportationClause)
          sopDataItem.push(ZH.constant.sop.MasterBLFreightTerm)
          sopDataItem.push(ZH.constant.sop.HBLFreightClause)
          sopDataItem.push(ZH.constant.sop.BRANCH_VESSEL)
          sopDataItem.push(ZH.constant.sop.BRANCH_VOYAGE)
          break
        case 'SI':
          sopDataItem.push(ZH.constant.sop.JOB_NO)
          sopDataItem.push(ZH.constant.sop.CUSTOMER_ID_CN)
          sopDataItem.push(ZH.constant.sop.CUSTOMER_ID_US)
          sopDataItem.push(ZH.constant.sop.WAREHOUSE_NO2)
          sopDataItem.push(ZH.constant.sop.LOADING_PORT_CODE)
          sopDataItem.push(ZH.constant.sop.LOADING_PORT_CODE3)
          sopDataItem.push(ZH.constant.sop.DESTINATION_PORT_CODE)
          sopDataItem.push(ZH.constant.sop.DESTINATION_PORT_CODE2)

          sopDataItem.push(ZH.constant.sop.CARRIER_CN)
          sopDataItem.push(ZH.constant.sop.CARRIER_US)
          sopDataItem.push(ZH.constant.sop.CARRIER_CODE)
          sopDataItem.push(ZH.constant.sop.CARRIER_SHORT_NAME)
          sopDataItem.push(ZH.constant.sop.VESSEL)
          sopDataItem.push(ZH.constant.sop.VOYAGE)
          sopDataItem.push(ZH.constant.sop.MBL)
          sopDataItem.push(ZH.constant.sop.HBL_NO)
          sopDataItem.push(ZH.constant.sop.TRANS_DATE)

          sopDataItem.push(ZH.constant.sop.DELIVER_DATE)
          sopDataItem.push(ZH.constant.sop.ARRIVE_STORAGE_DATE)
          sopDataItem.push(ZH.constant.sop.CUSTOMER_REF_NO2)
          sopDataItem.push(ZH.constant.sop.STATUS_UPDATE_TIME)
          sopDataItem.push(ZH.constant.sop.USER_DEFINED_FIELD1)
          sopDataItem.push(ZH.constant.sop.USER_DEFINED_FIELD2)
          sopDataItem.push(ZH.constant.sop.USER_DEFINED_FIELD3)

          sopDataItem.push(ZH.constant.sop.CONTAINER_DESC)
          sopDataItem.push(ZH.constant.sop.CONTAINER_NO)
          sopDataItem.push(ZH.constant.sop.CSR)
          sopDataItem.push(ZH.constant.sop.CSR_PHONE)
          sopDataItem.push(ZH.constant.sop.CSR_EMAIL)
          sopDataItem.push(ZH.constant.sop.DC_EMAIL)
          sopDataItem.push(ZH.constant.sop.CUSTOMS_DATE)

          sopDataItem.push(ZH.constant.sop.OP_EMAIL)
          sopDataItem.push(ZH.constant.sop.DESTINATION_AGENT_EMAIL)
          sopDataItem.push(ZH.constant.sop.MBLTransportationClause)
          sopDataItem.push(ZH.constant.sop.HBLTransportationClause)
          sopDataItem.push(ZH.constant.sop.MasterBLFreightTerm)
          sopDataItem.push(ZH.constant.sop.HBLFreightClause)
          break
        case 'AE':
          sopDataItem.push(ZH.constant.sop.JOB_NO)
          sopDataItem.push(ZH.constant.sop.CUSTOMER_ID_CN)
          sopDataItem.push(ZH.constant.sop.CUSTOMER_ID_US)
          sopDataItem.push(ZH.constant.sop.DESTINATION_AGENT)
          sopDataItem.push(ZH.constant.sop.DESIGNATION_AGENT)
          sopDataItem.push(ZH.constant.sop.LOADING_PORT_CODE2)

          sopDataItem.push(ZH.constant.sop.DESTINATION_PORT_CODE)
          sopDataItem.push(ZH.constant.sop.DESTINATION_PORT_CODE2)
          sopDataItem.push(ZH.constant.sop.CARRIER_ID_CN)
          sopDataItem.push(ZH.constant.sop.CARRIER_ID_US)
          sopDataItem.push(ZH.constant.sop.VOYAGE_FLIGHT)
          sopDataItem.push(ZH.constant.sop.ETD2)
          sopDataItem.push(ZH.constant.sop.ETA2)

          sopDataItem.push(ZH.constant.sop.CUSTOMER_REF_NO2)
          sopDataItem.push(ZH.constant.sop.WAREHOUSE_NO2)
          sopDataItem.push(ZH.constant.sop.MBL2)
          sopDataItem.push(ZH.constant.sop.HAWB)
          sopDataItem.push(ZH.constant.sop.STATUS_UPDATE_TIME)
          sopDataItem.push(ZH.constant.sop.QUANTITY)

          sopDataItem.push(ZH.constant.sop.WEIGHT)
          sopDataItem.push(ZH.constant.sop.VOLUME)
          sopDataItem.push(ZH.constant.sop.CONSIGNEE_CODE)
          sopDataItem.push(ZH.constant.sop.USER_DEFINED_FIELD1)
          sopDataItem.push(ZH.constant.sop.USER_DEFINED_FIELD2)
          sopDataItem.push(ZH.constant.sop.USER_DEFINED_FIELD3)

          sopDataItem.push(ZH.constant.sop.CSR)
          sopDataItem.push(ZH.constant.sop.CSR_PHONE)
          sopDataItem.push(ZH.constant.sop.CSR_EMAIL)
          sopDataItem.push(ZH.constant.sop.DC_EMAIL)
          sopDataItem.push(ZH.constant.sop.CUSTOMS_DATE)
          sopDataItem.push(ZH.constant.sop.OP_EMAIL)
          sopDataItem.push(ZH.constant.sop.DESTINATION_AGENT_EMAIL)
          sopDataItem.push(ZH.constant.sop.CUTOFF_TIME)
          sopDataItem.push(ZH.constant.sop.MasterBLFreightTerm)
          sopDataItem.push(ZH.constant.sop.HBLFreightClause)
          break
        case 'AI':
          sopDataItem.push(ZH.constant.sop.JOB_NO)
          sopDataItem.push(ZH.constant.sop.CUSTOMER_ID_CN)
          sopDataItem.push(ZH.constant.sop.CUSTOMER_ID_US)
          sopDataItem.push(ZH.constant.sop.CARRIER_ID_CN)
          sopDataItem.push(ZH.constant.sop.CARRIER_ID_US)
          sopDataItem.push(ZH.constant.sop.VOYAGE_FLIGHT)

          sopDataItem.push(ZH.constant.sop.LOADING_PORT_CODE2)
          sopDataItem.push(ZH.constant.sop.DESTINATION_PORT_CODE)
          sopDataItem.push(ZH.constant.sop.DESTINATION_PORT_CODE2)
          sopDataItem.push(ZH.constant.sop.MBL)
          sopDataItem.push(ZH.constant.sop.HBL_NO)
          sopDataItem.push(ZH.constant.sop.DELIVER_DATE)
          sopDataItem.push(ZH.constant.sop.ARRIVE_STORAGE_DATE)
          sopDataItem.push(ZH.constant.sop.TRANS_DATE)

          sopDataItem.push(ZH.constant.sop.CUSTOMER_REF_NO2)
          sopDataItem.push(ZH.constant.sop.STATUS_UPDATE_TIME)
          sopDataItem.push(ZH.constant.sop.USER_DEFINED_FIELD1)
          sopDataItem.push(ZH.constant.sop.USER_DEFINED_FIELD2)
          sopDataItem.push(ZH.constant.sop.USER_DEFINED_FIELD3)
          sopDataItem.push(ZH.constant.sop.CSR)
          sopDataItem.push(ZH.constant.sop.CSR_PHONE)
          sopDataItem.push(ZH.constant.sop.CSR_EMAIL)

          sopDataItem.push(ZH.constant.sop.DC_EMAIL)
          sopDataItem.push(ZH.constant.sop.CUSTOMS_DATE)
          sopDataItem.push(ZH.constant.sop.OP_EMAIL)
          sopDataItem.push(ZH.constant.sop.DESTINATION_AGENT_EMAIL)
          sopDataItem.push(ZH.constant.sop.MasterBLFreightTerm)
          sopDataItem.push(ZH.constant.sop.HBLFreightClause)
          break
      }

      return sopDataItem
    }
  },
  watch: {
    'sopForm.templateTheme'(val) {
      if (val) {
        this.getTheme(val)
      }
    }
  },
  created() {
    this.fileTreeGrid.gridOptions = {
      onRowSelected: (event) => {
        this.onFileTypeRowCheck(event)
      }, ... this.fileTreeGrid.gridOptions
    }
    this.loadTemplateList()
    this.loadTriggerTypeList()
    this.loadSopExternalCodeConfigList()
  },

  mounted() {
    console.log('treeNode', this.treeNode)
    this.initTrackingDetailForm = deepClone(this.trackingDetailForm)
    this.initSopFrom = deepClone(this.sopForm)
  },
  destroyed() {
  },
  methods: {
    onShow(trackingDetailUuid, allChildrenCount = 1) {
      this.initStatus()
      if (this.isNew && this.sourceType.parent) {
        this.trackingDetailForm.level = allChildrenCount + 1
      }
      this.init(trackingDetailUuid)
    },
    onEditorFocus(quill) {
      this.eFocus = this.constant.eFocus.emailContent
    },
    onFileTypeRowCheck(event) {
      const chooseRows = getGridSelected(this.fileTreeGrid.gridOptions)
      const smallishfileType = Array.from(chooseRows, row => { return { code: row.code, chineseName: row.chineseName } })
      if (smallishfileType && smallishfileType.length > 0) {
        this.currFileTypeNames = Array.from(smallishfileType, type => type.chineseName).reduce((p, l) => {
          return p + ',' + l
        })
        this.sopForm.fileId = Array.from(smallishfileType, type => type.code).reduce((p, l) => p + ',' + l)
      } else {
        this.currFileTypeNames = ''
        this.sopForm.fileId = ''
      }
    },
    onSopReady(params) {
      setTimeout(function() {
        params.api.sizeColumnsToFit()
      })
      window.addEventListener('resize', function() {
        setTimeout(function() {
          params.api.sizeColumnsToFit()
        })
      })
    },
    onSopRowClick(event) {
      // 查看sop
      // this.showEditSop(false)
    },
    onClickSopDataItem(index) { // 点击sop数据项的button
      const btnContent = this.sopDataItems[Number(index)]

      // const tempEmailText = this.sopForm.templateText2Email
      if (this.eFocus === this.constant.eFocus.emailTitle) {
        this.sopForm.templateTitle2Email += `\$\{${btnContent}\}`
      } else if (this.eFocus === this.constant.eFocus.emailContent) {
        //  解析editor html标签，将带追加的内容，放置最后一个标签中
        const lastChild = this.emailTextQuillEditor.container.children[0].lastChild
        if (lastChild.innerHTML !== '<p><br></p>') {
          lastChild.innerHTML = lastChild.innerHTML + `\$\{${btnContent}}`
          this.sopForm.templateText2Email = this.emailTextQuillEditor.container.children[0].innerHTML
        } else {
          this.sopForm.templateText2Email += `\$\{${btnContent}}`
        }

        this.$nextTick(function() {
          // this.$refs.emailTextQuillEditor.quill.enable(true)
          this.emailTextQuillEditor.blur()
        })
      } else {
        this.$refs['emailTextQuillEditor'].focus()
        this.eFocus = this.constant.eFocus.emailContent
      }
    },
    initStatus() { // trackingDetail 的状态初始
      if (this.sourceType.parent) {
        this.isNew = true
        this.optStatus.edit = true
      }
      if (this.sourceType.self) {
        this.isNew = false
        this.optStatus.edit = false
      }
    },
    async init(trackingDetailUuid) {
      this.loading = getLoading()
      trackingDetailUuid = trackingDetailUuid || this.treeNode.uuid
      if (this.sourceType.self) {
        await getTrackingDetailByUuid(trackingDetailUuid).then(res => {
          const form = { ...res.data }
          if (form.innerConfig) {
            form.innerConfig = JSON.parse(form.innerConfig)
            form.innerConfig.userList = form.innerConfig.userList ? form.innerConfig.userList.split(',').map(item => Number(item)) : []
          } else {
            form.innerConfig = deepClone(this.initTrackingDetailForm.innerConfig)
          }

          this.trackingDetailForm = { ...form }
          // 加载触发类型联动
          if (this.trackingDetailForm.event) {
            const triggerObj = this.triggerTypeList.find(op => op.uuid === this.trackingDetailForm.event)
            this.currentTriggerObj = { ...triggerObj }
          }
        }).catch((err) => {
          console.log('error--.>', err)
        }).finally(() => {
          this.loading.close()
        })
      } else {
        this.loading.close()
      }
      this.$refs['trackWarningConfig'].loadTrackSopWarningConfig(trackingDetailUuid)
      this.$refs['trackNotifyExt'].loadTrackingDetailNotifyExt(trackingDetailUuid)
      this.loadDocTypeByLob()
      if (!this.isNew) {
        this.queryChargeSchemeDetailTracking()
      }
    },
    async checkForm() {
      const { code, stateType, event, type, codeCname, codeEname } = { ...this.trackingDetailForm }
      await Assert.isNotBlank(code, this.$t('SystemMaintenance.PleaseEnterTheCode'))
      await Assert.isNotBlank(codeCname, this.$t('SystemMaintenance.PleaseEnterChineseName'))
      await Assert.isTrue(codeCname.length < 20, this.$t('SystemMaintenance.ChineseNameLengthExceeds20'))
      await Assert.isNotBlank(codeEname, this.$t('SystemMaintenance.PleaseEnterEnglishName'))
      await Assert.isNotBlank(stateType, this.$t('SystemMaintenance.PleaseSelectStatusType'))
      await Assert.isTrue(!type || event, this.$t('SystemMaintenance.PleaseSelectTriggerType'))
      await Assert.isNotBlank(stateType, this.$t('SystemMaintenance.PleaseSelectStatusType2'))
      await Assert.isTrue(!this.existProperty('code', code), this.$t('SystemMaintenance.ThereSameCodePleaseEnter'))
      await Assert.isTrue(!this.existProperty('codeCname', codeCname), this.$t('SystemMaintenance.ThereSameChineseNameEnter'))
      await Assert.isTrue(!this.existProperty('codeEname', codeEname), this.$t('SystemMaintenance.ThereSameEnglishNameEnter'))
    },
    existProperty(property, value) {
      // 同状态下的不同明细，属性值是否相同
      const row = this.trackingList.find(row => row[property] === value && row.trackingUuid === this.trackingDetailForm.trackingUuid && this.trackingDetailForm.uuid !== row.uuid)
      return !!row
    },
    fillModel() {
      this.$refs['trackNotifyExt'].fillModel()
      // this.$refs['trackNoteByInside'].fillModel()
    },
    async save() {
      await this.checkForm()

      this.loading = getLoading()
      this.trackingDetailForm.lob = this.currentLob
      // convert innerConfig
      if (this.needUpdateBrothers()) {
        const list = this.updateBrothers()
        list.push(this.trackingDetailForm)
        await saveTrackingDetailBatch(list).then(resp => {
          this.$refs['trackWarningConfig'].save()
        })
      } else {
        const body = {}
        Object.assign(body, this.trackingDetailForm)
        body.innerConfig.userList = body.innerConfig.userList.join(',')
        body.innerConfig = JSON.stringify(body.innerConfig)
        // 为新增设置 trackingUuid
        body.trackingUuid = this.treeNode.path.split(',')[1]
        await saveTrackingDetail(body, this.trackingDetailForm.uuid).then(async res => {
          const { uuid, trackingUuid, codeEname: englishName, codeCname: chineseName, code } = { ...res.data }
          this.saveChargeSchemeDetailTracking(uuid)
          this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
          const data = { path: `${this.currentLob},${trackingUuid},${uuid}`, type: 3, uuid, code, parentUuid: trackingUuid, chineseName, englishName }
          this.$emit('refreshTree', { action: this.isNew ? 'add' : 'edit', data })
          this.$refs['trackWarningConfig'].save(trackingUuid, uuid)
          this.$refs['trackNotifyExt'].save(uuid)
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    saveChargeSchemeDetailTracking(uuid) {
      const params = {}
      const list = []
      if (this.chargeSchemeDetailTrackingList) {
        for (const d of this.chargeSchemeDetailTrackingList) {
          if (!d.parentUuid) {
            list.push(d.uuid)
          }
        }
      }
      params.cUuid = list
      params.uuid = uuid
      saveChargeSchemeDetailTrackingFunc(params).finally(() => {
        this.loading.close()
      })
    },
    needUpdateBrothers() {
      const rows = this.trackingList.filter(row => row.trackingUuid === this.trackingDetailForm.trackingUuid)
      let need
      for (const row of rows) {
        if (row.level === this.trackingDetailForm.level && row.uuid !== this.trackingDetailForm.uuid) {
          need = true
          break
        }
      }
      return need
    },
    updateBrothers() {
      const list = []
      const rows = this.trackingList.filter(row => row.trackingUuid === this.trackingDetailForm.trackingUuid)
      for (const t of rows) {
        if (t.level >= this.trackingDetailForm.level && t.uuid !== this.trackingDetailForm.uuid) {
          list.push(t)
        }
      }
      for (const d of list) {
        d.level++
      }
      return list
    },
    cancel() {
      if (this.sourceType.parent) {
        this.$emit('refreshTree', { action: 'cancel', data: { uuid: this.treeNode.uuid, parentUuid: this.treeNode.uuid }})
      } else {
        this.initStatus()
        this.init()
      }
    },
    async toDel() {
      await this.$confirm(this.$t('common.tips.confirmDelete') + `<span style="color:red">注意：将会删除所关联的业务明细和sop节点</span>`, this.$t('common.tips.confirm'), { dangerouslyUseHTMLString: true, type: 'warning' })
      const loading = getLoading()
      delTrackingDetail(this.treeNode.uuid).then(res => {
        const { trackingUuid: parentUuid } = this.trackingDetailForm
        this.$message.success(this.$t('SystemMaintenance.DeleteSuccess'))
        this.$emit('refreshTree', { action: 'delete', data: { uuid: parentUuid, parentUuid }})
      }).finally(() => {
        loading.close()
      })
    },
    showEdit() {
      this.optStatus.edit = true
    },
    showAdd() {
      this.initStatus()
      this.optStatus.edit = true
      this.trackingDetailForm = deepClone(this.initTrackingDetailForm)

      const rows = this.trackingList.filter(row => row.parentUuid === this.treeNode.parentUuid)
      if (rows && rows.length > 0) {
        rows.sort((a, b) => Number(b.level) - Number(a.level))
        this.trackingDetailForm.level = rows[0].level + 1
      }
      this.isNew = true
    },
    toConfigSop() {
      this.fetchSopGridData()
      this.showSop = true
      this.optStatus.sopEdit = true
      this.optStatus.edit = false
    },
    async checkSopForm() {
      const { templateTitle2Email,
        templateText2Email,
        templateTitle2Note,
        templateText2Note } = { ...this.sopForm }
      await Assert.isNotBlank(this.trackingDetailForm.uuid, this.$t('SystemMaintenance.BusinessDetailsDoNotExist'))
      if (this.sopForm.pushChannel === 0) {
        await Assert.isNotBlank(templateTitle2Email, this.$t('SystemMaintenance.PleaseEnterTheSubjectTemplate'))
        await Assert.isNotBlank(templateText2Email, this.$t('SystemMaintenance.PleaseTheTextTemplateContent'))
      } else {
        await Assert.isNotBlank(templateTitle2Note, this.$t('SystemMaintenance.PleaseEnterTheTemplateContent'))
        await Assert.isNotBlank(templateText2Note, this.$t('SystemMaintenance.PleaseEnterTheTemplateExample'))
      }
    },
    async saveSop() {
      await this.checkSopForm()
      this.loading = getLoading()
      if (this.sopForm.pushChannel === 0) {
        // email
        this.sopForm.templateText = this.sopForm.templateText2Email
        this.sopForm.templateTitle = this.sopForm.templateTitle2Email
      } else {
        // note
        // this.sopForm.templateTheme
        this.sopForm.templateText = this.sopForm.templateText2Note
        this.sopForm.templateTitle = this.sopForm.templateTheme
        this.sopForm.fileId = ''
      }
      this.sopForm.trackingDetailUuid = this.trackingDetailForm.uuid
      this.sopForm.lob = this.currentLob
      saveTrackingSop(this.sopForm, this.sopForm.uuid).then(async res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        await this.fetchSopGridData()
        this.cancelSopCellEdit()
      }).finally(() => {
        this.loading.close()
      })
    },
    async delSop() {
      const cell = this.sopGrid.gridOptions.api.getFocusedCell()
      const nodes = this.sopGrid.gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      if (!node || !node.data) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectDataFirst'))
        return
      }
      // await Assert.isTrue(!this.optStatus.sopEdit, '当前处于编辑状态，不可删除')
      await this.$confirm(this.$t('SystemMaintenance.AreToDeleteTheRecord'), this.$t('SystemMaintenance.Prompt'), { type: 'waring' })
      this.loading = getLoading()
      delTrackingSop(node.data.uuid).then(async res => {
        await this.fetchSopGridData()
        this.showAddSop()
      }).finally(() => this.loading.close())
    },
    showAddSop() {
      this.isNewSop = true
      this.sopForm = { ...this.initSopFrom }
      this.currFileTypeNames = ''
      this.optStatus.sopEdit = true
    },
    showEditSop(sopEdit, uuid) {
      if (!uuid) {
        const cell = this.sopGrid.gridOptions.api.getFocusedCell()
        const nodes = this.sopGrid.gridOptions.api.rowModel.rowsToDisplay
        const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
        if (!node || !node.data) {
          this.$message.warning(this.$t('SystemMaintenance.PleaseSelectDataFirst'))
          return
        }
        uuid = node.data.uuid
      }
      this.optStatus.sopCellEdit = true
      this.loading = getLoading()
      getTrackingSopDetail(uuid).then(res => {
        this.isNewSop = false
        this.sopForm = { ...this.initSopFrom, ...res.data }

        this.fileTreeGrid.gridOptions.api.forEachNode((node) => {
          node.setSelected(this.sopForm.fileId.split(',').includes(node.data.code))
        })

        if (this.sopForm.pushChannel === 0) {
          this.sopForm.templateTitle2Email = this.sopForm.templateTitle
          this.sopForm.templateText2Email = this.sopForm.templateText
        } else {
          // note
          this.sopForm.templateTheme = this.sopForm.templateTitle
          // 和 watch 同步sync
          this.getTheme(this.sopForm.templateTheme)
        }
        this.optStatus.sopEdit = sopEdit
      }).finally(() => {
        this.loading.close()
      })
    },
    getTheme(val) {
      getTemplateTheme(val).then(res => {
        this.sopForm.templateTitle2Note = res.data.logRichNoteEditor
        this.sopForm.templateText2Note = res.data.richNoteEditor
      })
    },
    async fetchSopGridData() {
      getDocCategoryTypeTreeByLob({ lob: this.currentLob, constructLobParent: false }).then(res => {
        this.fileTreeGrid.rowData = res.data
      })
      await getTrackingSopList({ trackingDetailUuid: this.trackingDetailForm.uuid }).then(res => {
        this.sopGrid.rowData = res.data
        this.loading.close()
      })
    },
    backTrackingDetail() {
      // 返回到 编辑维护 trackingDetail状态
      this.showSop = false
    },
    async saveSopCellEdit() {
      await this.saveSop()
      this.optStatus.sopCellEdit = false
    },
    cancelSopCellEdit() {
      this.optStatus.sopCellEdit = false
      this.currFileTypeNames = ''
      Object.assign(this.sopForm, this.initSopFrom)
    },
    cancelSop() { // 取消编辑sop
      this.optStatus.sopEdit = false
      this.showSop = false
    },
    showSendSopTest() { // 发送测试
      this.sendSopTest.visible = true
    },
    sendSopTestHandler() {
      const text = this.sendSopTest.target
      // 是否测试邮箱
      const ifEmail = this.sopForm.pushChannel === 0
      if (ifEmail) {
        if (!text) {
          this.$message.warning(this.$t('SystemMaintenance.PleaseTheTestEmailAddress'))
          return
        }
        if (text && text.indexOf('@') === -1) {
          this.$message.warning(this.$t('SystemMaintenance.EmailFormatError'))
          return
        }
        if (text && text.length > 128) {
          this.$message.warning(this.$t('SystemMaintenance.EmailCannotExceed128Characters'))
          return
        }
        const params = {}
        params.key = text
        params.templateConfig = this.getTrackingTemplateData()
        const loading = getLoading()
        TrackingTemplateConfigApi.sendTestEmail(params).then(resp => {
          this.testSuccessHandler(resp)
        }).finally(() => loading.close())
      } else {
        if (!text) {
          this.$message.warning(this.$t('SystemMaintenance.PleaseEnterTestMobileNumber'))
          return
        }
        const regex = /^[0-9]*$/
        if (text && !regex.test(text)) {
          this.$message.warning(this.$t('SystemMaintenance.MobileOnlyBeANumber'))
          return
        }
        if (text && text.length !== 11) {
          this.$message.warning(this.$t('SystemMaintenance.MobileNumberFormatError'))
          return
        }
        const params = {}
        params.key = text
        params.templateConfig = this.getTrackingTemplateData()
        const loading = getLoading()
        TrackingTemplateConfigApi.sendTestNote(params).then(resp => {
          this.testSuccessHandler(resp)
        }).finally(() => loading.close())
      }
    },
    /**
     * 封装数据
     * @return
     */
    getTrackingTemplateData() {
      const t = {}
      t.lob = this.currentLob
      t.pushObject = this.sopForm.pushObject
      t.pushChannel = this.sopForm.pushChannel
      if (this.sopForm.pushChannel === 0) {
        t.templateTitle = this.sopForm.templateTitle2Email
        t.templateText = this.sopForm.templateText2Email
      } else if (this.sopForm.pushChannel === 1) {
        t.templateTitle = this.sopForm.templateTheme
        t.templateText = this.sopForm.templateTitle2Note
      }
      if (this.sopForm.fileId) {
        t.fileId = this.sopForm.fileId
      }
      t.trackingDetailUuid = this.treeNode.uuid
      t.pushNode = this.treeNode.codeCname
      return t
    },
    testSuccessHandler(resp) {
      const result = resp.data
      if (result > 0) {
        this.$message.success(this.$t('SystemMaintenance.SendingSuccessful'))
      } else {
        this.$message.error(this.$t('SystemMaintenance.SendingFailed'))
      }
      this.sendSopTest.visible = false
    },
    sendSopTestCloseHandler() {
      this.sendSopTest.visible = false
      this.sendSopTest.target = ''
    },
    getValueFromChild(obj) {
      this.trackingDetailForm[obj.key] = obj.value
      if (obj.key === 'event') { // 触发类型
        this.currentTriggerObj = { ...obj }
      }
    },
    getInnerConfigValueFromChild(obj) {
      this.trackingDetailForm.innerConfig[obj.key] = obj.value
    },
    loadTemplateList() {
      if (!this.templateList || this.templateList.length === 0) {
        templateApi.getTemplateList({ templateUsage: 1 }).then(resp => {
          this.templateList = resp.data
        })
      }
    },
    loadTriggerTypeList() {
      if (!this.triggerTypeList || this.triggerTypeList.length === 0) {
        entityTriggerTypeApi.getEntityTriggerTypeList().then(resp => {
          this.triggerTypeList = resp.data
        })
      }
    },
    loadSopExternalCodeConfigList() {
      if (!this.sopExternalCodeConfigList || this.sopExternalCodeConfigList.length === 0) {
        sopExternalCodeConfigApi.querySopExternalCode().then(resp => {
          this.sopExternalCodeConfigList = resp.data
        })
      }
    },
    selectHandler() {
      this.chargePlanDialog.selectList = this.chargeSchemeDetailTrackingList
      this.chargePlanDialog.lob = this.currentLob
      this.chargePlanDialog.isSea = this.currentLob === 'SE'
      this.chargePlanDialog.visible = true
    },
    selectedSchemeHandler(data) {
      this.chargeSchemeDetailTrackingList = data
      this.txtCharge = ''
      if (data) {
        const texChargeList = data.filter(p => p.chargeItemId === '')
        for (const d of texChargeList) {
          if (!d.parentUuid) {
            if (this.txtCharge) {
              this.txtCharge += ';'
            }
            this.txtCharge += d.name
          }
        }
      }
    },
    loadDocTypeByLob() {
      const lob = this.treeNode.path.split(',')[0]
      if (!this.docTypeMap.has(lob)) {
        getDocTypeByLob(lob).then(resp => {
          this.documentTypeList = resp.data
          this.docTypeMap.set(lob, resp.data)
        })
      }
    },
    queryChargeSchemeDetailTracking() {
      if (!this.trackingDetailForm || !this.trackingDetailForm.uuid) {
        this.txtCharge = ''
        return
      }
      queryChargeSchemeDetailTrackingFunc(this.trackingDetailForm.uuid, this.$store.getters.currentOfficeId).then(resp => {
        this.chargeSchemeDetailTrackingList = []
        if (resp.data && resp.data.list) {
          this.chargeSchemeDetailTrackingList = resp.data.list
          this.selectedSchemeHandler(resp.data.list)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .not-click {
    pointer-events: none;
    cursor: not-allowed
  }
  .tracking-detail .box-card>>>.el-card__header{
    padding:8px 20px!important;
    div{
      display: flex;
      justify-content: space-between;
    }
  }
  .tracking-detail .box-card>>>.el-card__body{
    height:calc(100% - 35px)!important;
  }
</style>
